export const weakFaireUrlRegex = /^[\S]*[Ff][Aa][Ii][Rr][Ee]\.[\S]+$/;
export const weakEmailRegex = /^(.+)@(.+).(.{2,})$/;
export const orderNumberRegex = /^[a-zA-Z0-9]+$/;
